/**
 * Setter for the VolumeTiers sub-tab's local UI state. The only piece of
 * state owned here is the visual order of rule rows (`orderedIds`) — the
 * actual rule data lives in the parent {@link FeeStructureController}.
 */
class VolumeTiersPanelDelegate {
    setOrderedIds(orderedIds) {
        this.setState({ orderedIds });
    }
}

export default VolumeTiersPanelDelegate;
